/** Baked at APK build time (see build_android.ps1 / CI). */
export function nativeAppStorageId(): string {
  const env = import.meta.env as Record<string, string | undefined> | undefined;
  const packageName = env?.VITE_ANDROID_PACKAGE_NAME?.trim();
  return packageName || 'com.couplespace.app';
}
